import React from 'react'
import HomeMain from '../components/home/HomeMain'
import HomeTests from '../components/home/HomeTests'
import HomeWhoWeAre from '../components/home/HomeWhoWeAre'
import HomeTestServices from '../components/home/HomeTestServices'
import HomeBookAppointment from '../components/home/HomeBookAppointment'
import HomeBloodTestResults from '../components/home/HomeBloodTestResults'
import HomeToxicologyResults from '../components/home/HomeToxicologyResults'
import HomeViruses from '../components/home/HomeViruses'
import HomeLabSolutions from '../components/home/HomeLabSolutions'
import HomePathogenPanelTesting from '../components/home/HomePathogenPanelTesting'
import HomeFaqs from '../components/home/HomeFaqs'
import MainHeader from '../layout/MainHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import ResponsiveHeader from '../layout/ResponsiveHeader'
import MainResHeader from '../layout/MainResHeader'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'

const HomePage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  
  return (
    <div style={{ overflow:'hidden'}}>

<HelmetProvider>
        <Helmet prioritizeSeoTags>
      <title>Lab Testing Services in Chicagoland Area | United Lab Care</title>
      <meta name="description" content="United Lab Care provides easy and fast laboratory testing. Get Covid-19, Influenza, RSV, and Respiratory Pathogen Panel testing services in Chicago." />
      <link rel="canonical" href="https://unitedlabcare.com/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Lab Testing Services in Chicagoland Area | United Lab Care" />
      <meta property="og:description" content="United Lab Care provides easy and fast laboratory testing. Get Covid-19, Influenza, RSV, and Respiratory Pathogen Panel testing services in Chicago." />
      <meta property="og:url" content="https://unitedlabcare.com/" />
      <meta property="og:site_name" content="United Lab Care" />
      <meta property="article:modified_time" content="2023-08-11T21:09:40+00:00" />
      <meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/01/United-Lab-Care-Logo-social-share.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />  
</Helmet>
</HelmetProvider>
        <TopHeader/>
        <MainResHeader/>
        {/* <MainHeader/> */}
        {/* <ResponsiveHeader/> */}

        <HomeMain/>
        <HomeTests/>
        <HomeWhoWeAre/>
        <HomeTestServices/>
        <HomeBookAppointment/>
        <HomeToxicologyResults/>
        <HomeBloodTestResults/>
        <HomeViruses/>
        <HomeLabSolutions/>
        <HomePathogenPanelTesting/>
        <HomeFaqs/>
        <div className='py-md-5'></div>
        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default HomePage